module.exports = __webpack_public_path__ + "static/media/Agri-Retailer Infographic desktop - GBR Tech - 16-05-2024 N (1).e8a23dc7.gif";